import { createStore } from 'vuex';
import lotteryStore from './views_lottery/helper/store';
import request from './utils/request'
import { isStaff } from "@/utils/api";

const store = createStore({
  state: {
    userInfo: null,
    examinationData: {},
    examinationVisible: false,
    examreslutVisible: false,
    previewBtn: false, // 银河传的值
    messageAppearDetailVisble: false, // 情报上报弹框
    // scrollTopValue: 0, // 上报记录滚动距离
    examId: '', // 考试试卷ID
    accessToken: '', // accessToken令牌   7f0003572ef54c37a8bd029e3de29b16
    refreshToken: '', // refreshToken令牌  e9ee30c3ea354772b50e1c06febeb09f
    versioncode: null, // 版本号  
    // haveOpenId 为 true 表示没有 getVersionCode 方法  或者  版本号 < 32102007
    haveOpenId: true, //  版本号 >= 32102007 不传openId 为 false 如果是 true 需要传openId
    isInternalUser: null, // 是否是内部用户
    isH5: false, // false 是 h5 true 是 小程序
    userOpenId: '', // 用户openId
    isStaff: false,
    token: '',
    location: '',
    pagelevel: '',
    userPhone: '',
    fullpath: 'no',
    search: '', // true 是搜索，false是地图戳点
    reportSearchWX: '', // 返回数据
    newPoi: false, // 地图戳点的新建
    islattest: false,
    messageAppearDetailVisblechange: false,
    // 小程序和h5使用cos下载功能时，拼接的sign
    signUrl: {
      "ishare": '',
      "mapugc-user": ''
    },
  },
  mutations: {
    SET_islattest(state, data) {
      state.islattest = data;
    },
    SET_userPhone(state, data) {
      state.userPhone = data;
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
    },
    SET_fullpath(state, data) {
      state.fullpath = data;
    },
    SET_examId(state, data) {
      state.examId = data;
    },
    SET_EXAMINATIONDATA(state, data) {
      state.examinationData = data;
    },
    SET_EXAMINATIONVISIBLE(state, data) {
      state.examinationVisible = data;
    },
    SET_EXAMRESLUTVISIBLE(state, data) {
      state.examreslutVisible = data;
    },
    SET_previewBtn(state, data) {
      state.previewBtn = data;
    },
    SET_messageAppearDetailVisble(state, data) {
      state.messageAppearDetailVisble = data;
    },
    SET_messageAppearDetailVisblechange(state, data) {
      state.messageAppearDetailVisblechange = data;
    },
    // SET_scrollTopValue(state, data) {
    //   state.scrollTopValue = data;
    // },
    SET_accessToken(state, data) {
      state.accessToken = data;
    },
    SET_refreshToken(state, data) {
      state.refreshToken = data;
    },
    SET_versioncode(state, data) {
      state.versioncode = data;
    },
    SET_haveOpenId(state, data) {
      state.haveOpenId = data;
    },
    SET_IsInternalUser(state, data) {
      state.isInternalUser = data;
    },
    SET_IsH5(state, data) {
      state.isH5 = data;
    },
    SET_isStaff(state, data) {
      state.isStaff = data;
    },
    SET_token(state, data) {
      state.isStaff = data;
    },
    setlocation(state, data) {
      state.location = data;
    }, 
    setuserOpenId(state, data) {
      state.userOpenId = data;
    }, 
    SET_page(state, data) {
      state.pagelevel = data;
    },
    SET_search(state, data) {
      state.search = data;
    },
    SET_reportSearchWX(state, data) {
      state.reportSearchWX = data;
    },
    SET_newPoi(state, data) {
      state.newPoi = data;
    },
    SET_signUrl(state, data) {
      state.signUrl[data.label] = data.value;
    },
  },
  actions: {
    SETIsH5({ commit }, data) {
      commit('SET_IsH5', data);
    },
    SETisStaff({ commit }, data) {
      commit('SET_isStaff', data);
    },
    setUserInfo({ commit }, data) {
      commit('SET_USERINFO', data);
    },
    setExaminationData({ commit }, data) {
      commit('SET_EXAMINATIONDATA', data);
    },
    setExamId({ commit }, data) {
      commit('SET_examId', data);
    },
    setExaminationVisible({ commit }, data) {
      commit('SET_EXAMINATIONVISIBLE', data);
    },
    setExamreslutvisible({ commit }, data) {
      commit('SET_EXAMRESLUTVISIBLE', data);
    },
    setPreviewBtn({ commit }, data) {
      commit('SET_previewBtn', data);
    },
    setMessageAppearDetailVisble({ commit }, data) {
      commit('SET_messageAppearDetailVisble', data);
    },
    // setScrollTopValue({ commit }, data) {
    //   commit('SET_scrollTopValue', data);
    // },
    setAccessToken({ commit }, data) {
      commit('SET_accessToken', data);
    },
    setRefreshToken({ commit }, data) {
      commit('SET_refreshToken', data);
    },
    setVersioncode({ commit }, data) {
      commit('SET_versioncode', data);
    },
    setSignUrl({ commit }, data) {
      commit('SET_signUrl', data);
    },
    setHaveOpenId({ commit }, data) {
      commit('SET_haveOpenId', data);
    },
    setIsInternalUser({ commit }) {
      request("POST", isStaff).then(res => {
        console.log(res, 'staff');
        if(res.code == 0 && res.data.is_staff == true){
          commit('SET_IsInternalUser', true);
        }else{
          commit('SET_IsInternalUser', false);
        }
      })
    },
  },
  getters: {
    userInfo: state => state.userInfo,
    examinationData: state => state.examinationData,
    examreslutVisible: state => state.examreslutVisible,
    examinationVisible: state => state.examinationVisible,
    previewBtn: state => state.previewBtn,
    messageAppearDetailVisble: state => state.messageAppearDetailVisble,
    // scrollTopValue: state => state.scrollTopValue,
    examId: state => state.examId,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    versioncode: state => state.versioncode,
    haveOpenId: state => state.haveOpenId,
    isH5: state => state.isH5,
  },
  modules: {
    lottery: lotteryStore
  }
});

export default store;